// @ts-nocheck
import React from 'react';
import {ReferralParentLoginView} from './view';
import ReferralParentLoginProvider from './state';
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';
interface IReferralParentLoginProps {
}

const ReferralParentLogin: React.FC<IReferralParentLoginProps> = () => (
    <ReferralParentLoginProvider>
        <ReferralParentLoginView/>
    </ReferralParentLoginProvider>
)

// Initialize global cache prevention
initGlobalCachePrevention();

const container = document.getElementById('referral-parent-container-wrap');

if(container){
    import('react-dom/client').then(({createRoot}) => {
        const root = createRoot(container);
        root.render(<ReferralParentLogin />);
    })
}

export default ReferralParentLogin;